<script>
import entreprise from "../../../assets/icons/ic-entreprise.svg";
import { updateService } from "@/component/cdevs/allFunctions";
import ic_deletePopup from "@/assets/icons/ic_deletePopup.svg";
import http from "@/plugins/https";
import apiroutes from "../../../router/api-routes";

export default {
  name: "AffectationPopup",
  components: {
    // VueSvgIcon,
  },
  data() {
    return {
      icons: { ic_deletePopup },
      charge: false,
    };
  },
  emits: ["closeDelete", "refresh"],
  props: {
    showPopup2: {
      type: Boolean,
      required: true,
    },
    serviceId: {
      type: String,
      required: true,
    },
  },
  methods: {
    // UnactiveUser function
    UnactiveUser() {
      this.charge = true;
      console.log("serviceId:", this.serviceId);

      http
        .delete(apiroutes.baseURL + apiroutes.unactive_user, {
          id: this.serviceId, // Passer l'ID de l'utilisateur à désactiver
        })
        .then(() => {
          this.charge = false;
          this.$toast.success("Entreprise désactivée avec succès");
          this.$emit("closeDelete", false);
          this.$emit("refresh");
        })
        .catch((error) => {
          this.charge = false;
          console.error("Erreur lors de la désactivation :", error);
        });
    },
  },
};
</script>

<template>
  <div class="popup-overlay">
    <div class="popup-content bg-white w-1/3 py-5 relative">
      <div class="flex font-c7 text-c24 px-5">Désactivation</div>
      <div class="mt-10">
        <icon
          :data="icons.ic_deletePopup"
          height="122"
          width="122"
          class="w-5 h-5"
          original
        />
        <div class="w-3/5 mx-auto mt-6">
          Êtes-vous sûr de vouloir désactiver cette entreprise ?
        </div>
      </div>
      <div class="mt-5">
        <div class="flex justify-end items-center mt-5 mx-5">
          <div
            class="font-c5 text-red-500 mt-2 text-sm ml-5 cursor-pointer annulerr px-7 py-3 rounded-8"
            @click="$emit('closeDelete', false)"
          >
            Annuler
          </div>
          <div
            class="text-red-500 mt-2 text-sm ml-5 cursor-pointer save px-20 py-3 rounded-8 text-white"
            @click="UnactiveUser"
          >
            Désactiver
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.annulerr {
  background-color: #eff4fb;
}
.save {
  background-color: #f35d49;
}
.colorBorderB {
  border-bottom: 3px solid #e7eef8;
}
.bgInpout {
  /* background-color: #F0F2F7; */
  border: 1px solid #f0f2f7;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 25rem;
}
.relative {
  position: relative;
}
</style>
